// extracted by mini-css-extract-plugin
module.exports = {"icon":"RedirectIcon_icon__2qWfV"};